export const buildNavRoute = (cr, currentRoute) => {
  let active = false
  if (cr.path !== '') {
    active = currentRoute.path.indexOf(cr.path) === 0
  } else if (cr.name === currentRoute.name) { // catch dashboard case
    active = true
  }
  let name
  // because an empty path is the dashboard and dashboard
  // is default child of base route at '/'
  let to = { 'path': cr.path !== '' ? cr.path : '/' }
  if (cr.meta.nav.childDefault) {
    name = cr.children[0].name
  } else {
    name = cr.meta.nav.name || cr.name
  }
  name = name.charAt(0).toUpperCase() + name.slice(1)
  return {
    name: name,
    to: to,
    icon: cr.meta.nav.icon,
    isActive: active
  }
}
